import React, { useState, useContext, useEffect } from "react";
import { TableContext } from "../../index";
import { showWarningToast } from "../../validation/ToastContainer";
import ChooseDeviceField from "./ChooseDeviceField";
import * as deviceService from "../../devices/deviceService";
import { Spinner } from "../../view/Spinner";
import SearchInputV2 from "../../view/SearchInputV2";

// import "./styles.css";

function ConfigChangesTableHeader() {

    const [devices, setDevices] = useState([]);
    const [deviceId, setDeviceId] = useState();
    const { config, setConfig } = useContext(TableContext);

    // Search state - stored in context so ConfigChangesTable can access it
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setConfig({ ...config, searchTerm: value });
    };

    const fetchData = async () => {
        try {
            const deviceList = await deviceService.list();
            setDevices(deviceList);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    const onCompareClick = async () => {
        if (config && config.selected.length !== 2) {
            showWarningToast('Please check only two Rows to Detect Configuration Changes?', 'Configuration Changes');
        }
        setConfig({
            ...config,
            detectDate: new Date()
        })
    }

    const showSpinner = false;

    return (
        <div className="oct_filter-section-v2">
            {/* Row 1: Choose Device + Detect Button */}
            <div className="row mb-3 align-items-end">
                <div className="col">
                    <label className="oct_filter-label">CHOOSE DEVICE</label>
                    <ChooseDeviceField setDeviceId={setDeviceId}
                        deviceId={deviceId}
                        devices={devices} />
                </div>
                <div className="col  d-flex justify-content-end">
                    <button onClick={onCompareClick} className="oct_btn-export-v2">
                        <span className={showSpinner ? 'spinner-visible' : ''}>
                            Detect Configurations Changes
                        </span>
                        {showSpinner && <Spinner />}
                    </button>

                </div>
            </div>

            {/* Row 2: Search Section */}
            <div className="mb-3">
                <SearchInputV2
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Search by device, IP address, user, or date"
                    className="m-0"
                />
            </div>
        </div>
    )
}

export default ConfigChangesTableHeader;